import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  files : [],
  countFiles: 0,


  filesInClient : [],
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/files/index.js